// GlobalChatContext.js
import { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export const useGlobalChat = () => useContext(ChatContext);

export function GlobalChatProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [chatConfig, setChatConfig] = useState({
    assistantMode: "roadmap",
    dayContext: null,
  });

  const openChat = (nextConfig = {}) => {
    setChatConfig({
      assistantMode: nextConfig.assistantMode || "roadmap",
      dayContext: nextConfig.dayContext || null,
    });
    setOpen(true);
  };

  const closeChat = () => {
    setOpen(false);
    setChatConfig({
      assistantMode: "roadmap",
      dayContext: null,
    });
  };

  return (
    <ChatContext.Provider
      value={{ open, setOpen, openChat, closeChat, chatConfig, setChatConfig }}
    >
      {children}
    </ChatContext.Provider>
  );
}
